import { cn } from '../utils/cn';
import { LOGO_PARTENERI } from '../utils/logo-parteneri';

/**
 * Banda „În parteneriat cu" + logo-ul Ministerului: pe `/autentificare` si pe «Acasă» (profesor).
 * Inaltimea e fixa, deci incarcarea imaginii nu misca pagina, nici dupa inlocuirea logo-ului.
 */
export function InParteneriatCu({ className }: { className?: string }) {
    return (
        <section aria-label="Parteneri" className={cn('flex flex-col items-center gap-1.5 sm:gap-2.5', className)}>
            <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
                În parteneriat cu
            </span>
            <img
                src={LOGO_PARTENERI.minister.src}
                alt={LOGO_PARTENERI.minister.alt}
                decoding="async"
                className="h-13 w-auto max-w-full sm:h-16"
            />
        </section>
    );
}

/** Magazinele de pe «Puncte și premii», sub sold, cu aceeasi forma de card ca `ProgresRang`. */
export function MagazinePartenere() {
    return (
        <section
            aria-label="Magazine partenere"
            className="flex min-w-0 flex-col gap-2 rounded-lg border border-hairline bg-card px-4 py-3 text-cerneala"
        >
            <p className="m-0 text-small">Magazine partenere pentru achiziția voucherelor</p>
            <div className="grid grid-cols-2 items-center gap-4">
                {[LOGO_PARTENERI.altex, LOGO_PARTENERI.carturesti].map(({ src, alt }) => (
                    <div key={src} className="flex items-center justify-center py-2">
                        <img src={src} alt={alt} decoding="async" className="h-7.5 w-auto max-w-full sm:h-10" />
                    </div>
                ))}
            </div>
        </section>
    );
}
